import { usePaymentPoliciesApi } from '@api/payment-policies/payment-policies.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void usePaymentPoliciesApi({ tutorId })
})
